import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Bookmarkable alias for the auth page.
 * /login          -> /auth?mode=login
 * /signin         -> /auth?mode=login
 * /login?next=/x  -> /auth?mode=login&next=/x
 */
const LoginAlias = () => {
  const [params] = useSearchParams();
  const next = params.get('next');
  const target = next
    ? `/auth?mode=login&next=${encodeURIComponent(next)}`
    : '/auth?mode=login';
  return <Navigate to={target} replace />;
};

export default LoginAlias;
